import { render, staticRenderFns } from "./ClerkPerformance.vue?vue&type=template&id=78ce989c&scoped=true"
import script from "./ClerkPerformance.vue?vue&type=script&lang=js"
export * from "./ClerkPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce989c",
  null
  
)

export default component.exports